import Lang from '@/mixins/Lang'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }
        
        Vue.mixin(Lang);

    }
}
